import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from '@digilize/shared/feature/modules/auth/src';

import { LoginModule } from './views/login/login.module';

const routes: Routes = [
  {
    path: 'course',
    canActivate: [LoggedInGuard],
    data: { customLoginRedirectRoute: '/auth' },
    loadChildren: () => import('./views/main.module').then((m) => m.MainModule),
  },
  {
    path: 'auth',
    loadChildren: () => LoginModule, // not lazy loaded as its first view for non logged user
  },
  {
    path: 'products',
    loadChildren: () => import('./views/products/products.module').then((m) => m.ProductsModule),
  },
  {
    path: 'orders',
    loadChildren: () => import('./views/orders/orders.module').then((m) => m.OrdersModule),
  },

  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 74],
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
